export const ARTICLES_PER_PAGE = 10;

export const CATEGORIES = [null];
